import { ScaleLimits } from './types';

export const getTicksAndFactor = (min, max) => {
  const range = max - min;
  let ticksArray = [];

  const setTicksArray = (factor) => {
    ticksArray[0] = min;
    if (min % factor > 0) {
      ticksArray[1] = min + factor - (min % factor);
    }
    let num = ticksArray[1] ?? ticksArray[0];
    while (num + factor < max) {
      ticksArray = [...ticksArray, num + factor];
      num += factor;
    }
    ticksArray.push(max);

    /**
     * inorder to prevent the overlapping of end numbers with their corresponding
     * adjacent numbers, removing the adjacent number from the ticks array if the
     * difference between it and its corresponding end number is less than half of the factor.
     */
    if (ticksArray[1] - ticksArray[0] < factor / 2) {
      ticksArray.splice(1, 1);
    }
    if (
      ticksArray[ticksArray.length - 1] - ticksArray[ticksArray.length - 2]
      < factor / 2
    ) {
      ticksArray.splice(ticksArray.length - 2, 1);
    }
  };

  let factor = 1;
  if (range <= 10) {
    setTicksArray(1);
  }
  if (range > 10 && range <= 20) {
    factor = 2;
    setTicksArray(2);
  }
  if (range > 20 && range <= 50) {
    factor = 5;
    setTicksArray(5);
  }
  if (range > 50 && range <= 100) {
    factor = 10;
    setTicksArray(10);
  }
  if (range > 100 && range <= 1000) {
    factor = 100;
    setTicksArray(100);
  }
  return { ticksArray, factor };
};

export const getBottomSliderMark = (limits: ScaleLimits, minValue: number) => {
  // Hide the bottom slider marker when lower range is equal to or beyond the limits
  if (
    minValue <= limits.min.value
    || minValue >= limits.max.value
    || !minValue
  ) {
    return '';
  }
  return minValue?.toString() ?? '';
};

export const getTopSliderMark = (limits: ScaleLimits, maxValue: number) => {
  // Hide the top slider marker when higher range is equal to or beyond the limits
  if (
    maxValue >= limits.max.value
    || maxValue <= limits.min.value
    || !maxValue
  ) {
    return '';
  }
  return maxValue?.toString() ?? '';
};

export const getRangeValue = (
  minValue: number,
  maxValue: number,
  limits: ScaleLimits,
) => {
  // if any of the range is not a number
  if (Number.isNaN(minValue) || Number.isNaN(maxValue)) {
    // if both ranges are not a number
    if (Number.isNaN(minValue) && Number.isNaN(maxValue)) {
      return [];
    }

    // If only one is not a number, return the other value twice as a range
    if (Number.isNaN(minValue)) {
      // checking max range value is within the limits
      if (limits.min.value <= maxValue && maxValue <= limits.max.value) {
        return [maxValue, maxValue];
      }
    }
    // checking min range value is within the limits
    if (limits.min.value <= minValue && minValue <= limits.max.value) {
      return [minValue, minValue];
    }
    return [];
  }

  // if the range values are out of the limits
  if (
    (minValue < limits.min.value && maxValue < limits.min.value)
    || (minValue > limits.max.value && maxValue > limits.max.value)
  ) {
    return [];
  }

  return [minValue, maxValue];
};
